import { render, staticRenderFns } from "./AdminStandardEditForm.vue?vue&type=template&id=1650ea6f"
import script from "./AdminStandardEditForm.vue?vue&type=script&lang=js"
export * from "./AdminStandardEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports